import React, { useState } from 'react';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import { Image, Loader, Modal, Stack } from '@mantine/core';
// import DocViewer, { JPGRenderer, MSDocRenderer,
//  PDFRenderer, PNGRenderer } from 'react-doc-viewer';
import PropTypes from 'prop-types';
import { DocumentViewer } from 'react-documents';
import { getExtensionFromUrl } from '../../../utils/format';
import { useFileDownloader } from '../../../utils/hooks';

const ButtonEvidence = ({ children, url = '', onClick = () => { } }) => {

  const extension = getExtensionFromUrl(url);
  const [opened, setOpened] = useState(false);

  const { downloadFile, isLoading } = useFileDownloader();

  // 1. Memoize the doc list so the reference doesn't change on every render
  //   const docList = useMemo(() => {
  //     console.log('ButtonEvidenceurl= ', url);
  //     if (!url) return [];
  //     return [
  //       {
  //         uri: url,
  //       }
  //     ];
  //   }, [url]);

  return (
    <>
      <Button className={styles.btnEvidence} onClick={() => {
        onClick();
        setOpened(true);
      }} style="primary-500">{children}</Button>
      <Modal centered onClose={() => setOpened(false)} opened={opened} size="xl" styles={{
        title: {
          fontWeight: 600,
          fontSize: 30
        }
      }} title="Dokumen Pendukung">
        <Stack>
          {['jpg', 'jpeg', 'png'].includes(extension)
            ? <Image height="100%" src={url} width="100%" />
            :
            <DocumentViewer
              className={'docsViewer'}
              style={{ width: '100%', height: '25rem' }}
              url={url}
              viewer={['doc', 'docx'].includes(extension) ? 'office' : 'url'}
            />}

          {/* <DocViewer config={{
            header: {
              disableFileName: true,
              disableHeader: true
            }
          }} documents={docList}
          pluginRenderers={[PDFRenderer, PNGRenderer, JPGRenderer, MSDocRenderer]}/> */}
          <Button disabled={isLoading} fullWidth onClick={() => downloadFile(url, 'Dokumen Pendukung')} outlined>
            {isLoading ? <Loader /> : 'Unduh Dokumen Pendukung'}
          </Button>
          <Button fullWidth onClick={() => setOpened(false)}>Tutup</Button>
        </Stack>
      </Modal>
    </>
  );
};

export default ButtonEvidence;

ButtonEvidence.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  url: PropTypes.string
};
